import { createContext, useContext, type ReactNode } from "react";
import type { SsrBlogIndexBootstrap } from "@shared/blogSsr";

const SsrBlogIndexContext = createContext<SsrBlogIndexBootstrap | undefined>(undefined);

export function SsrBlogIndexProvider({
  data,
  children,
}: {
  data?: SsrBlogIndexBootstrap;
  children: ReactNode;
}) {
  return <SsrBlogIndexContext.Provider value={data}>{children}</SsrBlogIndexContext.Provider>;
}

export function useSsrBlogIndex(): SsrBlogIndexBootstrap | undefined {
  return useContext(SsrBlogIndexContext);
}
